import React, { useState, useEffect } from "react";
import { useEmailAccessTokenMutation } from "@/services/api";
import { FlowEmbed } from "./FlowEmbed";
import { useAccess } from "./WithAccess";
import { useRequiredInfo } from "./WithInfo";
import { ContextLogin } from "@Light/components/auth/login/ContextLogin";
import { ContextCheckEmail } from "@Light/components/auth/login/ContextCheckEmail";
import { WithHeader } from "@Light/components/page/header/Header";
import { Overlay } from "@Light/components/page/Overlay";
import { getErrorMessage } from "@/utils/errors";
import { setupSessionFreshnessCheck } from "@Light/utils/sessionFreshness";

export const Portal: React.FC = () => {
  useEffect(() => {
    const cleanup = setupSessionFreshnessCheck();
    return cleanup;
  }, []);
  const info = useRequiredInfo();
  const access = useAccess();
  const [emailSent, setEmailSent] = useState(false);
  const [emailAccessToken, { isLoading, error }] =
    useEmailAccessTokenMutation();

  const handleSendEmail = async () => {
    try {
      await emailAccessToken().unwrap();
      setEmailSent(true);
    } catch (err) {
      // Error handling is done by the mutation hook
      console.error("Failed to send email access token:", err);
    }
  };

  if (!access?.flow_login_link) {
    return (
      <Overlay>
        <WithHeader>
          {!emailSent ? (
            <ContextLogin
              email={info.email}
              onSendEmail={handleSendEmail}
              isLoading={isLoading}
              error={getErrorMessage(error, "Failed to send email")}
            />
          ) : (
            <ContextCheckEmail
              email={info.email}
              onResendEmail={handleSendEmail}
              isLoading={isLoading}
              error={getErrorMessage(error, "Failed to send email")}
            />
          )}
        </WithHeader>
      </Overlay>
    );
  }

  return <FlowEmbed src={access.flow_login_link} />;
};
